export default __webpack_public_path__ + "static/media/misc-books3-1024w.61250f1d.avif";